import { render, staticRenderFns } from "./process-choose.vue?vue&type=template&id=5ad944d5&"
import script from "./process-choose.vue?vue&type=script&lang=js&"
export * from "./process-choose.vue?vue&type=script&lang=js&"
import style0 from "./process-choose.vue?vue&type=style&index=0&id=5ad944d5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports